<template>
    <div class="app-container">
        <el-row :gutter="20">
            <el-col :offset="3" :span="18">
                <user-data :user="user" />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import UserData from "./components/UserData";

export default {
    name: "Profile",
    components: {
        UserData
    },
    data() {
        return {
            user: {}
        };
    },
    watch: {
        $route: "getUser"
    },
    created() {
        this.getUser();
    },
    methods: {
        async getUser() {
            const data = await this.$store.dispatch("user/getInfo");
            this.user = data;
        }
    }
};
</script>
